// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2wuEm","approved":"Status_approved__3641b","rejected":"Status_rejected__10lVf","expired":"Status_expired__NJuRQ","label":"Status_label__1eAJ-"};